"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Dollar = () => /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
}, /*#__PURE__*/_react.default.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: "#FFF",
  stroke: "#CFD8DC",
  d: "M6.5 19.5h26v2h-26z"
}), /*#__PURE__*/_react.default.createElement("path", {
  fill: "#CFD8DC",
  d: "M8 25h1v1H8zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zM6 25h1v1H6zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zM6 27h1v1H6zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zM8 27h1v1H8zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zM8 13h1v1H8zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zM6 13h1v1H6zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zM6 15h1v1H6zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zM8 15h1v1H8zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zm4 0h1v1h-1zM20 36l-5-5h10zm0-31l5 5H15z"
})));

var _default = Dollar;
exports.default = _default;